
// Gallery.js

import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import {
  FiZoomIn,
  FiX,
  FiMapPin,
  FiGrid,
  FiLayers
} from "react-icons/fi";


const fadeUp = keyframes`

from{
opacity:0;
transform:translateY(30px);
}

to{
opacity:1;
transform:translateY(0);
}

`;



const SectionWrapper = styled.section`

padding:6rem 1.5rem;


background:${({theme})=>theme.colors.white};


`;



const Container = styled.div`

max-width:1280px;

margin:auto;

`;



const HeaderContainer = styled.div`

max-width:750px;

margin:0 auto 3.5rem;

text-align:center;

`;



const SectionBadge = styled.div`

display:inline-flex;

align-items:center;

gap:8px;


padding:.45rem 1.2rem;


border-radius:50px;


background:${({theme})=>theme.colors.primaryLight};


color:${({theme})=>theme.colors.primary};


font-size:.8rem;


font-weight:800;


letter-spacing:.1em;


text-transform:uppercase;


margin-bottom:1rem;


`;



const SectionTitle = styled.h2`

font-size:clamp(2rem,4vw,3rem);


font-weight:800;


line-height:1.15;


letter-spacing:-1px;


color:${({theme})=>theme.colors.textDark};


margin-bottom:1rem;


`;



const SectionSubtitle = styled.p`

font-size:1.05rem;


line-height:1.7;


color:${({theme})=>theme.colors.textMuted};


`;




const FilterContainer = styled.div`

display:flex;

justify-content:center;

align-items:center;


gap:.8rem;


flex-wrap:wrap;


margin-bottom:3rem;


`;



const FilterButton = styled.button`

padding:.65rem 1.4rem;


border-radius:50px;


font-size:.85rem;


font-weight:700;


background:${({active,theme})=>

active

?theme.colors.primary

:theme.colors.bgAccent

};


color:${({active,theme})=>

active

?theme.colors.white

:theme.colors.textDark

};


border:1px solid ${({active,theme})=>

active

?theme.colors.primary

:theme.colors.border

};


transition:${({theme})=>theme.transitions.default};



&:hover{

transform:translateY(-3px);

border-color:${({theme})=>theme.colors.primary};


}


`;




const Grid = styled.div`

display:grid;


grid-template-columns:repeat(3,1fr);


gap:1.8rem;



@media(max-width:${({theme})=>theme.breakpoints.desktop}){

grid-template-columns:repeat(2,1fr);

}


@media(max-width:${({theme})=>theme.breakpoints.mobile}){

grid-template-columns:1fr;

}


`;




const Card = styled.div`

height:360px;


position:relative;


overflow:hidden;


border-radius:24px;


cursor:pointer;


background:${({theme})=>theme.colors.bgDark};


box-shadow:

0 12px 30px rgba(15,23,42,.08);


animation:${fadeUp}.6s ease both;


transition:${({theme})=>theme.transitions.default};



&:hover{

transform:translateY(-8px);

box-shadow:

0 25px 50px rgba(15,23,42,.18);

}



&:hover img{

transform:scale(1.12);

}



&:hover .overlay{

opacity:1;

}


`;




const CardImage = styled.img`

width:100%;

height:100%;


object-fit:cover;


transition:.6s;


`;




const CardOverlay = styled.div`

position:absolute;

inset:0;


display:flex;

flex-direction:column;


justify-content:flex-end;


padding:1.7rem;


background:

linear-gradient(

180deg,

transparent 20%,

rgba(15,23,42,.9)

);


transition:.4s;


`;




const CategoryTag = styled.span`

font-size:.75rem;


font-weight:800;


text-transform:uppercase;


letter-spacing:.08em;


color:#86efac;


margin-bottom:.4rem;


`;




const CardTitle = styled.h3`

font-size:1.2rem;


font-weight:800;


line-height:1.3;


color:white;


margin-bottom:.5rem;


`;




const CardLocation = styled.div`

display:flex;

align-items:center;


gap:6px;


font-size:.85rem;


color:#cbd5e1;


`;





const ZoomBadge = styled.div`

position:absolute;


top:1rem;


right:1rem;


width:42px;


height:42px;


border-radius:50%;


display:flex;

align-items:center;

justify-content:center;


background:rgba(0,0,0,.45);


color:white;


backdrop-filter:blur(10px);


font-size:1.1rem;


`;





const ModalOverlay = styled.div`

position:fixed;


inset:0;


z-index:3000;


background:rgba(15,23,42,.92);


backdrop-filter:blur(12px);


display:flex;


align-items:center;


justify-content:center;


padding:1.5rem;


`;





const ModalContent = styled.div`

position:relative;


max-width:1000px;


width:100%;


border-radius:28px;


overflow:hidden;


background:${({theme})=>theme.colors.bgDark};


box-shadow:

0 30px 80px rgba(0,0,0,.4);


`;




const ModalImage = styled.img`

width:100%;


max-height:600px;


object-fit:cover;


`;




const ModalDetails = styled.div`

padding:1.5rem 2rem;


display:flex;


justify-content:space-between;


align-items:center;


gap:1rem;


color:white;



h3{

font-size:1.4rem;

font-weight:800;

}



p{

color:#cbd5e1;

font-size:.9rem;

}



@media(max-width:${({theme})=>theme.breakpoints.mobile}){

flex-direction:column;

align-items:flex-start;

}


`;




const CloseButton = styled.button`

position:absolute;


right:1rem;


top:1rem;


z-index:5;


width:42px;


height:42px;


border-radius:50%;


background:rgba(0,0,0,.6);


color:white;


font-size:1.2rem;


display:flex;

align-items:center;

justify-content:center;


&:hover{

background:${({theme})=>theme.colors.primary};

}


`;






export default function Gallery(){


const [activeFilter,setActiveFilter]=useState("All");

const [selectedProject,setSelectedProject]=useState(null);



const categories=[

"All",

"Tiling Work",

"Plaster & Renders",

"Commercial",

"Residential"

];



const projects=[


{
id:1,
title:"Large Porcelain Floor Installation",
category:"Tiling Work",
type:"Residential",
location:"Sharjah, UAE",
image:"https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80"
},


{
id:2,
title:"Smooth Interior Wall Plastering",
category:"Plaster & Renders",
type:"Residential",
location:"Al Nasiriya, Sharjah",
image:"https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1200&q=80"
},


{
id:3,
title:"Commercial Showroom Floor Tiling",
category:"Tiling Work",
type:"Commercial",
location:"Dubai, UAE",
image:"https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?auto=format&fit=crop&w=1200&q=80"
},


{
id:4,
title:"Exterior Facade Cement Render",
category:"Plaster & Renders",
type:"Commercial",
location:"Sharjah Industrial Area",
image:"https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1200&q=80"
},


{
id:5,
title:"Luxury Villa Marble Wall Tiling",
category:"Tiling Work",
type:"Residential",
location:"Sharjah, UAE",
image:"https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&w=1200&q=80"
},


{
id:6,
title:"Office Complex Subfloor Leveling",
category:"Plaster & Renders",
type:"Commercial",
location:"Sharjah, UAE",
image:"https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1200&q=80"
}


];



const filteredProjects=

activeFilter==="All"

?projects

:projects.filter(

item=>

item.category===activeFilter ||

item.type===activeFilter

);



return(


<SectionWrapper id="projects">


<Container>


<HeaderContainer>


<SectionBadge>

<FiGrid/>

Our Portfolio

</SectionBadge>



<SectionTitle>

Featured Contracting Projects

</SectionTitle>



<SectionSubtitle>

Explore our premium plastering, tiling, and architectural finishing projects delivered across UAE.

</SectionSubtitle>


</HeaderContainer>




<FilterContainer>


{

categories.map(cat=>(


<FilterButton

key={cat}

active={activeFilter===cat}

onClick={()=>setActiveFilter(cat)}

>

{cat}

</FilterButton>


))


}



</FilterContainer>





<Grid>


{

filteredProjects.map((project,index)=>(


<Card

key={project.id}

style={{

animationDelay:`${index*.1}s`

}}

onClick={()=>setSelectedProject(project)}

>


<CardImage

src={project.image}

alt={project.title}

/>


<ZoomBadge>

<FiZoomIn/>

</ZoomBadge>



<CardOverlay>


<CategoryTag>

{project.category} • {project.type}

</CategoryTag>



<CardTitle>

{project.title}

</CardTitle>



<CardLocation>

<FiMapPin/>

{project.location}

</CardLocation>


</CardOverlay>


</Card>


))


}


</Grid>



</Container>




{

selectedProject &&

<ModalOverlay

onClick={()=>setSelectedProject(null)}

>


<ModalContent

onClick={(e)=>e.stopPropagation()}

>


<CloseButton

onClick={()=>setSelectedProject(null)}

>

<FiX/>

</CloseButton>



<ModalImage

src={selectedProject.image}

alt={selectedProject.title}

/>



<ModalDetails>


<div>

<CategoryTag>

{selectedProject.category} | {selectedProject.type}

</CategoryTag>


<h3>

{selectedProject.title}

</h3>


</div>


<p>

{selectedProject.location}

</p>



</ModalDetails>



</ModalContent>


</ModalOverlay>


}




</SectionWrapper>


);


}
